import {ClickAwayListener} from "@mui/base";
import Card from "./Card";
import {Box, Divider, Stack, Typography} from "@mui/joy";
import {TeamPreview, TeamResponse} from "../types/team";

type TeamSearchResultItemProps = {
    team: TeamPreview,
    onSelect: (teamPreview: TeamPreview) => void
}

type TeamSearchComponentProps = {
    searchBarResultsOpen: boolean,
    anchor: React.ReactNode
    onCloseSearch?: () => void
    onSelectItem?: (teamId: TeamPreview) => void
    searchResult?: TeamResponse[]
}

const TeamSearchComponent = (props: TeamSearchComponentProps) => {
    return <ClickAwayListener onClickAway={() => props.onCloseSearch?.()}>
        <Stack gap={0.5}>
            {props.anchor}
            {props.searchBarResultsOpen &&
                <Card variant={"outlined"}
                      sx={{
                          maxHeight: "20rem", overflowY: "auto",
                          backgroundColor: "background.surface",
                          padding: 0,
                          boxShadow: "lg",
                          zIndex: 20
                      }}>
                    <Stack>
                        {props.searchResult?.map((value, index, array) =>
                            <Stack key={value.team?.id ?? index}>
                                <SearchResultItemComponent
                                    onSelect={() => props.onSelectItem(value.team)}
                                    team={value.team}
                                />
                                {index !== array.length - 1 && <Divider/>}
                            </Stack>
                        )}
                    </Stack>
                </Card>}
        </Stack>
    </ClickAwayListener>
}

const SearchResultItemComponent = (props: TeamSearchResultItemProps) => {
    return <Stack direction={"row"} onClick={() => props.onSelect(props.team)}
                  alignItems="center" paddingX={{xs: 2, sm: 4}} paddingY={1.5}
                  sx={{
                      cursor: "pointer",
                      ":hover": {
                          backgroundColor: "primary.100",
                      }
                  }}>

        <Typography
            startDecorator={<Box component={"img"} sx={{objectFit: "cover", backgroundColor: "transparent"}} width={27}
                                 src={props.team.logo}/>} level={"body-lg"}>
            {props.team.name}
        </Typography>
    </Stack>
}

export default TeamSearchComponent